import dayjs from 'dayjs';
import { IUpdate } from './types';

export const updates: IUpdate[] = [
    {
        title: 'התנגשות הזמנות בזמן אמת',
        description:
            'אם שני משתמשים עורכים את אותה הזמנה במקביל, המערכת מזהה את זה בלייב ומציגה מה אצלכם מול מה בשרת — שורה מול שורה. בוחרים מה לשמור, בלי לדרוס בטעות את העבודה של מישהו אחר. מסך הזמנות מתעדכן בזמן אמת כשיש שינוי.',
        date: dayjs().year(2026).month(8).date(11)
    },
    {
        title: 'עוזר חג בלינק הזמנות',
        description:
            "בהגדרות לינק (לקוחות → הזמנות → הגדרות לינק) נוסף כפתור 'עוזר חג': מגדירים חלון הזמנה לחג או מבצע — למי פתוח (כולם / לפי כרטיס / נבחרים), אילו מוצרים, ובאילו תאריכים. אפשר גם לחסום ימים. במקום להגדיר הכל ידנית לכל מוצר.",
        date: dayjs().year(2026).month(8).date(11),
        featureId: 'customer-order-link'
    },
    {
        title: 'עד 3 צילומי שטח למסמך',
        description:
            'לכל מסמך אפשר לצרף עד 3 צילומי שטח במקום צילום אחד. כפתור המצלמה מציג את מספר הצילומים, ובחלון הצפייה יש חצים מעל התמונה למעבר בין הצילומים — התמונה מימין והמסמך משמאל. אפשר להוסיף צילום נוסף (תמונה או PDF) או למחוק צילום קיים, גם מהאפליקציה וגם מכרטיס הלקוח. גרסאות אפליקציה ישנות ממשיכות לעבוד ומציגות את הצילום הראשון',
        date: dayjs().year(2026).month(7).date(27)
    },
    {
        title: 'היסטוריית מחיר והקמת מחירונים',
        description:
            'במחירון הלקוח, ליד שם המוצר, כפתור היסטוריה פותח ציר זמן של שינויי מחיר בשנתיים האחרונות — לחיצה על נקודה מאפשרת לערוך מחיר והנחה לאותו תאריך. ברשימת לקוחות יש כפתור הקמת מחירון: נוצר לקוח-מחירון שאפשר לשייך ללקוחות ולנהל בו מחירים בנפרד.',
        date: dayjs().year(2026).month(7).date(24)
    },
    {
        title: 'תמונה והוראות הגעה לנהג בכרטיס לקוח',
        description:
            'בכרטיס לקוח אפשר לצלם או להעלות תמונה של המקום ולכתוב הוראות הגעה. הנהג רואה את התמונה ואת ההוראות מההזמנות ומהכרטיס — כדי לזהות את הכניסה בלי להתקשר.',
        date: dayjs().year(2026).month(7).date(24)
    },
    {
        title: 'מחירי תקליט במסמכים',
        description:
            "בתעודת משלוח (כרטיס לקוח) אפשר למשוך מחירי תקליט למוצרים המקושרים לתקליט — כפתור 'משוך מחירי תקליט'. ביצירת תעודה חדשה המחירים נמשכים אוטומטית למוצרים שעדיין לא עודכנו. פעיל רק לחברות עם תקליט מופעל",
        date: dayjs().year(2026).month(7).date(11)
    },
    {
        title: 'שדרוג לינק הזמנות ל־V2',
        description:
            "תחת לקוחות → הזמנות → הגדרות לינק (מרכז שליטה) אפשר להעביר את לינקי החברה ל־V2 בעצמכם (טאב 'יכולות v2'). כולל חלונות הזמנה מתוחמים למוצרים (חג/מבצע — חסימה או פתיחה לפי מוצרים ותאריכים), נעילות שעה למוצרים, חסימת חגים וסגירות, חסימת לקוח לפי אשראי/חוב, שעות סגירה לפי יום, עיצוב חנות וערכות צבעים, צ׳יפ תמיכה בוואטסאפ, אזור אישי (מסמכים, סטטוס הזמנות, הורדת PDF), סטטיסטיקת רכישה, הודעה קופצת, שדות חובה לפני שליחה, בקרת מלאי/אשראי/יחידות, טפסי עדכון לקוח עם מסמכים וחתימה דיגיטלית, לקוחות מזדמנים (BTC) ובדיקת מדיניות כלקוח",
        date: dayjs().year(2026).month(7).date(9)
    },
    {
        title: 'הפקדות',
        description:
            "מסך חדש תחת לקוחות → מסמכים → הפקדות. ריכוז מזומן וצ'קים שטרם הופקדו (כולל צ'קים שהגיע זמנם וצ'קים דחויים), יצירת הפקדה לחשבון בנק, הפקדה לפי סכום במזומן, סינון לפי תאריך קבלה או תאריך פרעון, מצב 'פתוח עד תאריך' או טווח תאריכים, דוח PDF וביטול הפקדה",
        date: dayjs().year(2026).month(7).date(9)
    },
    {
        title: 'הגדרות לינק הזמנות',
        description:
            'מסך חדש תחת לקוחות → הזמנות → הגדרות לינק. ניהול נעילת הזמנות, שעות סגירה לפי יום, מחירים, הזמנות מרובות וחסימת תאריכים (חגים) — כולל ניקוי אוטומטי של תאריכים שעברו',
        date: dayjs().year(2026).month(5).date(6)
    },
    {
        title: 'העתק והעבר הזמנה ללקוח אחר',
        description:
            "במסך הזמנות (טאבלה): תפריט קליק ימני → פעולות להזמנות → 'העתק ללקוח אחר' או 'העבר ללקוח אחר'. בוחרים לקוח יעד מהרשימה, מאשרים — ההזמנה (כולל מוצרים) מועתקת או מועברת ללקוח הנבחר",
        date: dayjs().year(2026).month(2).date(10)
    },
    {
        title: 'הצעות מחיר',
        description:
            'מסך חדש תחת לקוחות → הצעות מחיר. ניתן ליצור הצעת מחיר כללית או ללקוח ספציפי, לחפש לפי מספר הצעה או לקוח, לצפות ב-10 האחרונות, להוריד PDF ולשתף בוואטסאפ',
        date: dayjs().year(2026).month(2).date(7)
    },
    {
        title: 'אינדיקטורי חיבור ווטסאפ וחשבונית ישראל',
        description: "כעת מוצגים בכותרת צ'יפים לחיבור ווטסאפ וחשבונית ישראל — מהבהבים אדום אם לא מחוברים, לחיצה מפנה לחיבור",
        date: dayjs().year(2026).month(2).date(4)
    },
    {
        title: 'שכפול תעודה',
        description: 'אפשר לשכפל תעודה קיימת לתעודה חדשה במסך יצירת תעודה מהכרטיס לקוח',
        date: dayjs().year(2026).month(1).date(5)
    },
    {
        title: 'מסך הזמנות מחוקות',
        description: 'תחת לקוחות , מסמכים, הזמנות מחוקות',
        date: dayjs().year(2026).month(1).date(5)
    },
    {
        title: 'ניכוי מס במקור אוטומתי באחוזים בקבלה',
        date: dayjs().year(2026).month(1).date(5)
    },
    {
        title: 'מס הקצאה החל מ10000',
        date: dayjs().year(2026).month(1).date(5)
    },
    {
        title: 'כפתור לצפות בכל ההודעות ווטסאפ ואימייל שנשלחו',
        description: 'ניתן ללחוץ למעלה על כפתור הודעות',
        date: dayjs().year(2025).month(4).date(18)
    },
    {
        title: 'שכפול תעודה לתעודה חדשה במסך יצירת תעודה מהכרטיס לקוח',
        description: 'כל חשבונית שתופק עם תאריך מסמך מעל 1.1.25 יתווסף מעמ 18% גם אם יצאו תעודות על שנת 24',
        date: dayjs().year(2024).month(11).date(22)
    },
    {
        title: 'תשלום חלקי על חשבוניות',
        description: 'ברגע שמסמנים חשבניות לסגירה התוכנה אוטומתית מחשבת מה פתוח וסגור',
        date: dayjs().year(2024).month(11).date(22)
    }
].sort((a, b) => b.date.valueOf() - a.date.valueOf());
